const ttManager = 'api/v1/tiktok_ads_manager';
const cabinet = `${ttManager}/cabinet`;

export default {
  cabinet,
  creativeTexts: `${cabinet}/texts`,
  flows: `${cabinet}/flows`,
  flowDetails: `${cabinet}/flows-details`,
  goToTest: `${cabinet}/go-to-test`,
  goToTestDetails: `${cabinet}/go-to-test-details`,
  accounts: `${ttManager}/accounts`,
};
